import { getField, updateField } from 'vuex-map-fields'
import axios from 'axios'
// import $ from 'jquery'
import router from '../../router'

export default{
  namespaced: true,
  state: {
    carrierInfo: {
      uname: '',
      card_ban: '',
      card_no1: '',
      card_no2: '',
      card_type: '',
      back_url: '',
      token: ''
    },
    startDate: '',
    endDate: '',
    carrierAry: [],
    basketref: '',
    CARD_URL: process.env.CARD_URL
  },
  actions: {
    getBasketRef ({commit}) {
      let basketref = window.tpxReadCookie('mawebhlbr')
      commit('setBasketref', {basketref})
    },
    init ({commit, state, dispatch}) {
      dispatch('getBasketRef')
      if (state.basketref === '') {
        alert('請先登入')
        router.push('/')
        return
      }
      commit('LOADING', true, {root: true})
      let API_PATH = process.env.API
      let basketref = state.basketref
      fetch(`${API_PATH}user/sessioninfo/${basketref}`, {method: 'POST'}).then(res => {
        return res.json()
      }).then(result => {
        let backUrl = `${API_PATH}invoicecarrier/aggrverify`
        // 目前uname=card_no1=card_no2
        // let cardNo1 = 'NW2P-' + result.data.userid + '-' + result.data.login
        let uname = result.data.emailaddress
        let cardBan = '38019423'
        let cardNo1 = result.data.emailaddress
        // 隱碼一定不能重覆(一個隱碼不可給不同的使用者)
        let cardNo2 = cardNo1
        let cardType = 'EG0364'
        axios.get(`${API_PATH}invoicecarrier/aggrprepare/${cardNo1}/${cardNo2}/${cardType}`).then(res => {
          console.log('token=' + res.data.data.token)
          console.log('en_cardno1=' + res.data.data.en_cardno1)
          console.log('en_cardno2=' + res.data.data.en_cardno2)
          console.log('en_cardtype=' + res.data.data.en_cardtype)
          console.log('backUrl=' + backUrl)
          let token = res.data.data.token
          let enCardNo1 = res.data.data.en_cardno1
          let enCardNo2 = res.data.data.en_cardno2
          let enCardType = res.data.data.en_cardtype
          commit('setToken', {token})
          commit('setParamenters', {uname, cardBan, enCardNo1, enCardNo2, enCardType, backUrl})
        })
      }).catch((error) => {
        console.error(error)
      }).finally(() => {
        commit('LOADING', false, {root: true})
      })
    },
    aggrCarrier ({commit, state, dispatch}) {
      dispatch('getBasketRef')
      if (state.basketref === '') {
        let message = '請先登入'
        let theme = 'danger'
        commit('changeMessage', {message, theme}, {root: true})
        router.push('/')
        return
      }
      /*
      if (state.carrierInfo['token'] === '') {
        alert('token產生失敗，請重試。')
        return
      }
      */
      commit('LOADING', true, {root: true})
      let API_PATH = process.env.API
      console.log('[aggrCarrier]')
      console.log(state.carrierInfo)
      fetch(`${API_PATH}invoicecarrier/aggrregister`, {method: 'POST',
        body: JSON.stringify(state.carrierInfo),
        headers: {
          'content-type': 'application/json'
        }
      }).then(res => {
        return res.json()
      }).then(result => {
        // commit('aggrCarrier', {result})
        if (result.error_code === 0) {
          if (result.data.result === 'Y') {
            console.log(state.CARD_URL.trim())
            if (state.CARD_URL.trim() !== '') {
              $('form').attr('action', state.CARD_URL)
              $('form').attr('target', '_blank')
              $('form').trigger('submit')
            }
          } else {
            alert('驗證有誤，請重新載入。')
          }
        } else {
          alert('系統錯誤，請重試。')
        }
      }).finally(() => {
        commit('LOADING', false, {root: true})
      })
    }
  },
  mutations: {
    updateField,
    aggrCarrier (state, {result}) {
      state.carriereAry = result
    },
    setBasketref (state, {basketref}) {
      state.basketref = basketref
    },
    setToken (state, {token}) {
      state.carrierInfo['token'] = token
    },
    setParamenters (state, {uname, cardBan, enCardNo1, enCardNo2, enCardType, backUrl}) {
      state.carrierInfo['uname'] = uname
      state.carrierInfo['card_ban'] = cardBan
      state.carrierInfo['card_no1'] = enCardNo1
      state.carrierInfo['card_no2'] = enCardNo2
      state.carrierInfo['card_type'] = enCardType
      state.carrierInfo['back_url'] = backUrl
    }
  },
  getters: {
    getField
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/carrierBelong.js